// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_9p-6";
export var headerCell = "_9p-2";
export var rowWrapper = "_9p-4";
export var table = "_9p-1";
export var virtualRowWrapper = "_9p-5";
export var virtualTableContainer = "_9p-0";
export var white = "_9p-3";